import {getDateUtilDefaultInstance} from '/util/date.util';

export const getDate = ({date}: any) => {
  const dateUtil = getDateUtilDefaultInstance();
  const formattedDate = dateUtil.formatDate(date, 'MMMM d, yyyy');
  return formattedDate;
};
